import React, { useState, useRef, useEffect } from 'react';
import i18n from "../../i18n/i18n.js";
import {useAppContext, useModalsContext, withAppContext } from '../../contexts/AppContext';
import './ProductsSlider.css';
import { Swiper, SwiperSlide  } from 'swiper/react';
import ProductListItem from '../ProductListItem/ProductListItem.js';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import { col, object } from 'framer-motion/client';




const ProductsSlider = (props) => {

    const appContext = useAppContext();
    const appRef = appContext.appRef.current;
    const modalsContext = useModalsContext();

    const boxTitle = props.boxTitle ? props.boxTitle : '';
    const products = props.products ? props.products : [];
    const backgroundColor = props.backgroundColor ? props.backgroundColor : '';
    const productBoxType = props.productBoxType ? props.productBoxType : 'default';
    const slideItemCount = props.slideItemCount ? props.slideItemCount : 1;
    const showDots = props.showDots !== undefined ? props.showDots : false;
    const showProductRating = props.showProductRating !== undefined ? props.showProductRating : false;
    const showFavIcon = props.showFavIcon !== undefined ? props.showFavIcon : false;
    const isTabProductBox = productBoxType === 'tabProductBox';
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const swiperRef = useRef(null);


    if(Array.isArray(products) && products.length===0){
        return null;
    }

    const productChunks = getProductChunks(products, slideItemCount);

    // Tab click handler
    const handleTabClick = (index) => {
        setActiveTabIndex(index);
        if (swiperRef.current && swiperRef.current.slideTo) {
            swiperRef.current.slideTo(index);
        }
    };

    return (
        <div className={`products-slider-box`} style={prepareBackgroundColor(backgroundColor)}>
            <h2 className='slider-box-title'>{boxTitle}</h2>
            <div className={`products-slider-wrapper showDots-${showDots} sliderType-${productBoxType} slideItemCount-${slideItemCount}`}>
                {isTabProductBox ? showTabs() : null}
                {renderProductSlides(productChunks, productBoxType, showDots)}
            </div>
        </div>
    );

    function showTabs() {
        // Only render if products is object
        if (typeof products !== 'object' || products === null || Array.isArray(products)) return null;
        return <div className='products-slider-tabs-controller'>
            {Object.keys(products).map((tab_key, index) => (
                <div
                    key={tab_key}
                    className={`slider-tab-item tab-${tab_key} ${activeTabIndex === index ? 'active' : ''}`}
                    onClick={() => handleTabClick(index)}
                    style={{ cursor: 'pointer' }}
                >
                    {products[tab_key].label}
                </div>
            ))}
        </div>
    }

    function getProductChunks(products, slideItemCount) {

        if (products.length === 0) {
            return [];
        }

        const chunks = [];

        if(productBoxType==='tabProductBox'){

            Object.keys(products).forEach((tab_key)=>{
                chunks.push(products[tab_key].products);
            });
            
        }else{

            for (let i = 0; i < products.length; i += slideItemCount) {
                chunks.push(products.slice(i, i + slideItemCount));
            }

        }
        
        return chunks;
    }

    function renderProductSlides(productChunks, productBoxType, showDots) {
        const slidesPerView = productBoxType === 'default' ? 2.5 : 1;
        return (
            <Swiper
                slidesPerView={slidesPerView}
                pagination={showDots ? { clickable: true } : false}
                spaceBetween={10}
                modules={[Pagination]}
                onSwiper={(swiper) => { swiperRef.current = swiper; }}
                initialSlide={isTabProductBox ? activeTabIndex : 0}
                onSlideChange={isTabProductBox ? (swiper) => setActiveTabIndex(swiper.activeIndex) : undefined}
            >
                {productChunks.map((chunk, chunkIdx) => (
                    <SwiperSlide key={chunkIdx}>
                        <div className='product-slide-item'>
                            {chunk.map(product => (
                                <ProductListItem show_product_rating={showProductRating} show_fav_icon={showFavIcon} key={product.id} product={product} renderStyle={productBoxType} />
                            ))}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        );
    }

    function prepareBackgroundColor(color) {
        const colors = color.split('|').map(c => c.trim()).filter(Boolean);

        if (colors.length > 1) {
            const c1 = colors[0] || '#FFF';
            const c2 = colors[1] || '#FFF';
            const c3 = colors[2] || '#FFF';
            return {
                background: `transparent linear-gradient(180deg, ${c1} 0%, ${c2} 69%, ${c3} 100%) 0% 0% no-repeat padding-box`
            };
        } else if (colors.length === 1) {
            return {
                backgroundColor: colors[0]
            };
        } else {
            return {};
        }
    }

    
};

export default withAppContext(ProductsSlider);